/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-26 15:06:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-07 14:05:00
 */

const weatherUrl =
  "https://api.seniverse.com/v3/weather/now.json?key=SnoH1RPeRf7M8y2tX&location=ip"
const weatherUpdateInterval = 300000

function ajax(opts) {
  var xhr = new XMLHttpRequest(),
    type = opts.type || "GET",
    url = opts.url,
    params = opts.data,
    dataType = opts.dataType || "json"

  type = type.toUpperCase()

  if (type === "GET") {
    params = (function(obj) {
      var str = ""

      for (var prop in obj) {
        str += prop + "=" + obj[prop] + "&"
      }
      str = str.slice(0, str.length - 1)
      return str
    })(opts.data)
    url += url.indexOf("?") === -1 ? "?" + params : "&" + params
  }

  xhr.open(type, url)

  xhr.send(params ? params : null)

  //return promise
  return new Promise(function(resolve, reject) {
    //onload are executed just after the sync request is comple，
    //please use 'onreadystatechange' if need support IE9-
    xhr.onload = function() {
      if (xhr.status === 200) {
        var result
        try {
          result = JSON.parse(xhr.response)
        } catch (e) {
          result = xhr.response
        }
        resolve(result)
      } else {
        reject(xhr.response)
      }
    }
  })
}

const weather = {
  /**
   * 获取天气
   */
  getWeather() {
    return new Promise((resolve, reject) => {
      if (weatherUrl) {
        ajax({
          url: weatherUrl,
          type: "get"
        }).then(res => {
          resolve(res)
        })
      } else {
        resolve(null)
      }
    })
  }
}

export { weather, weatherUpdateInterval }
